import { TokenClass } from 'swap-sdk/entities/token'

interface WarningTokenList {
  [key: string]: TokenClass
}

const SwapWarningTokens = <WarningTokenList>{}

export default SwapWarningTokens
